export const SUBMIT_SUBSTANCE_COSANNEXE_FORM = 'substanceCosAnnexeForm/SUBMIT_SUBSTANCE_COSANNEXE_FORM';